import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';

const styles = () => ({
  circularProgress: {
    display: 'block',
    margin: 'auto',
  },
  container: {
    maxHeight: 250,
    overflowY: 'auto',
    padding: 15,
    position: 'relative',
    zIndex: 10,
    '&::-webkit-scrollbar': {
      '-webkit-appearance': 'none',
    },
    '&::-webkit-scrollbar:vertical': {
      width: 11,
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 8,
      border: '2px solid white', /* should match background, can't be transparent */
      backgroundColor: 'rgba(0, 0, 0, .3)',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#fff',
      borderRadius: 8,
    },
  },
  list: { padding: 0 },
  listItem: { marginBottom: 10 },
  listItemBtn: { padding: 3 },
});

const DropdownItems = ({ absolute, loading, options, classes }) => {
  if (!options.length && !loading) return false;

  return (
    <Paper className={classes.container} style={{ position: absolute ? 'absolute' : 'relative' }}>
      { loading ? (
        <CircularProgress className={classes.circularProgress} />
      ) : (
        <List className={classes.list}>
          {
            options.map(({
              id,
              primaryText,
              secondaryText,
              onClick,
            }, index) => (
              <ListItem
                button
                classes={{ button: classes.listItemBtn }}
                key={id || index}
                onClick={onClick}
              >
                <ListItemText
                  primary={primaryText}
                  secondary={secondaryText}
                />
              </ListItem>
            ))
          }
        </List>
      )}
    </Paper>
  );
};

DropdownItems.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  absolute: PropTypes.bool,
  loading: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({}),
  ).isRequired,
};

DropdownItems.defaultProps = {
  absolute: false,
  loading: false,
};

export default withStyles(styles)(DropdownItems);
